import { Icon24PauseSolid } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const PauseFilledIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_822_591)">
        <path
          d="M9 3.96533C9.72479 3.96533 10.3124 4.55307 10.3125 5.27783V20.2778C10.3125 21.0027 9.72487 21.5903 9 21.5903H5.25C4.52513 21.5903 3.9375 21.0027 3.9375 20.2778V5.27783C3.93763 4.55307 4.52521 3.96533 5.25 3.96533H9ZM18.75 3.96533C19.4748 3.96533 20.0624 4.55307 20.0625 5.27783V20.2778C20.0625 21.0027 19.4749 21.5903 18.75 21.5903H15C14.2751 21.5903 13.6875 21.0027 13.6875 20.2778V5.27783C13.6876 4.55307 14.2752 3.96533 15 3.96533H18.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_822_591">
          <rect width="24" height="24" fill="white" transform="translate(0 0.777832)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PauseFilledIcon = fplIcon(PauseFilledIconLocal, Icon24PauseSolid);
